var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 5.99994H8.5901L5.2901 2.70994C5.1018 2.52164 4.99601 2.26624 4.99601 1.99994C4.99601 1.73364 5.1018 1.47825 5.2901 1.28994C5.47841 1.10164 5.7338 0.99585 6.0001 0.99585C6.26641 0.99585 6.5218 1.10164 6.7101 1.28994L11.7101 6.28994C11.8011 6.38505 11.8725 6.49719 11.9201 6.61994C12.0201 6.8634 12.0201 7.13648 11.9201 7.37994C11.8725 7.50269 11.8011 7.61484 11.7101 7.70994L6.7101 12.7099C6.61714 12.8037 6.50654 12.8781 6.38468 12.9288C6.26282 12.9796 6.13212 13.0057 6.0001 13.0057C5.86809 13.0057 5.73739 12.9796 5.61553 12.9288C5.49367 12.8781 5.38307 12.8037 5.2901 12.7099C5.19637 12.617 5.12198 12.5064 5.07121 12.3845C5.02044 12.2627 4.99431 12.132 4.99431 11.9999C4.99431 11.8679 5.02044 11.7372 5.07121 11.6154C5.12198 11.4935 5.19637 11.3829 5.2901 11.2899L8.5901 7.99994H1.0001C0.734887 7.99994 0.480533 7.89458 0.292996 7.70705C0.10546 7.51951 0.000103951 7.26516 0.000103951 6.99994C0.000103951 6.73472 0.10546 6.48037 0.292996 6.29283C0.480533 6.1053 0.734887 5.99994 1.0001 5.99994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxarrow);
export default __webpack_public_path__ + "static/media/boxarrow.a266a73e1599786360fb78e54c07f899.svg";
export { ForwardRef as ReactComponent };